import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDynamicComponent as _resolveDynamicComponent, Transition as _Transition } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    itemprop: "image",
    class: "ui-logo",
    src: "/static/img/logo-rope-risk-clean.png",
    alt: "Logo"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Início", -1)
const _hoisted_4 = { class: "ui-flex-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", null, "Segurados", -1)
const _hoisted_6 = { class: "ui-flex-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", null, "Inspeções", -1)
const _hoisted_8 = { class: "ui-flex-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "Configurações", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "ui-logos-seguradoras" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: "/static/img/logos-seguradoras.jpg",
    alt: "Seguradoras parceiras: Zurich, HDI, AIG, Allianz, Sompo, Avla e Tokio Marine"
  })
], -1)
const _hoisted_11 = { class: "ant-row" }
const _hoisted_12 = { class: "ant-col ant-col-xs-1 ant-col-xl-1" }
const _hoisted_13 = { class: "ant-col ant-col-xs-13 ant-col-xl-18 ui-d-none-mob" }
const _hoisted_14 = {
  key: 0,
  itemprop: "image",
  style: {"float":"left","max-height":"40px","object-fit":"contain","margin-left":"20px","margin-top":"8px"},
  class: "ui-logo",
  src: "/static/img/logo-rope-risk-clean.png",
  alt: "Logo"
}
const _hoisted_15 = { class: "ant-col ant-col-xs-10 ant-col-xl-5" }
const _hoisted_16 = { class: "ui-dados-usuario" }
const _hoisted_17 = { class: "ui-dados-usuario-identificacao" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_sub_menu = _resolveComponent("a-sub-menu")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_layout_sider = _resolveComponent("a-layout-sider")!
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_layout_header = _resolveComponent("a-layout-header")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_a_layout_content = _resolveComponent("a-layout-content")!
  const _component_a_layout = _resolveComponent("a-layout")!

  return (!_ctx.storeApp.state.carregando)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_a_layout, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_layout_sider, {
              class: "ui-sider",
              theme: "light",
              breakpoint: "lg",
              "collapsed-width": "0",
              collapsed: _ctx.collapsed,
              "onUpdate:collapsed": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.collapsed) = $event)),
              trigger: null,
              collapsible: ""
            }, {
              default: _withCtx(() => [
                _hoisted_2,
                _createVNode(_component_a_menu, {
                  selectedKeys: _ctx.selectedKeys,
                  "onUpdate:selectedKeys": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedKeys) = $event)),
                  mode: "inline"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_menu_item, {
                      key: "1",
                      style: {"display":"none"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_router_link, {
                          class: "ui-flex-center",
                          to: { name: 'Inspecoes' }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_icone, {
                              class: "ui-menu",
                              nome: "home"
                            }),
                            _hoisted_3
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    (_ctx.verificaPossuiPrivilegio('CADASTROS'))
                      ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: { name: 'Segurados' } }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_4, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "empresa"
                                  }),
                                  _hoisted_5
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (_ctx.verificaPossuiPrivilegio('INSPECOES'))
                      ? (_openBlock(), _createBlock(_component_a_menu_item, { key: "3" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_router_link, { to: { name: 'Inspecoes' } }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_6, [
                                  _createVNode(_component_icone, {
                                    class: "ui-menu",
                                    nome: "historico"
                                  }),
                                  _hoisted_7
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    ((_ctx.storeApp.state.usuarioAutenticado.codigo !== 7))
                      ? (_openBlock(), _createBlock(_component_a_sub_menu, { key: "5" }, {
                          title: _withCtx(() => [
                            _createElementVNode("div", _hoisted_8, [
                              _createVNode(_component_icone, {
                                class: "ui-menu",
                                nome: "configuracoes"
                              }),
                              _hoisted_9
                            ])
                          ]),
                          default: _withCtx(() => [
                            (_ctx.verificaPossuiPrivilegio('USUARIOS'))
                              ? (_openBlock(), _createBlock(_component_a_menu_item, {
                                  class: "ui-menu-item",
                                  key: "6"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'Usuarios' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Usuários ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["selectedKeys"]),
                _hoisted_10
              ]),
              _: 1
            }, 8, ["collapsed"]),
            _createVNode(_component_a_layout, {
              class: _normalizeClass(_ctx.collapsed?'':'ui-content')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_layout_header, { class: "ui-layout-navbar" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("div", {
                          class: _normalizeClass(_ctx.collapsed?'ui-menu-expand':'ui-menu-expand ui-f-right-mob'),
                          onClick: _cache[2] || (_cache[2] = () => (_ctx.collapsed = !_ctx.collapsed))
                        }, [
                          (_ctx.collapsed)
                            ? (_openBlock(), _createBlock(_component_icone, {
                                key: 0,
                                nome: "menu-max"
                              }))
                            : (_openBlock(), _createBlock(_component_icone, {
                                key: 1,
                                nome: "menu-min"
                              }))
                        ], 2)
                      ]),
                      _createElementVNode("div", _hoisted_13, [
                        (_ctx.collapsed)
                          ? (_openBlock(), _createElementBlock("img", _hoisted_14))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createVNode(_component_a_dropdown, { trigger: ['click'] }, {
                          overlay: _withCtx(() => [
                            _createVNode(_component_a_menu, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_menu_item, { key: "15" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_router_link, { to: { name: 'UsuarioMeusDados' } }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(" Meus dados ")
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_a_menu_item, {
                                  key: "16",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.deslogar()))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("Sair")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          default: _withCtx(() => [
                            _createElementVNode("a", {
                              class: "ant-dropdown-link",
                              onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
                            }, [
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_a_avatar, null, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.storeApp.getters.primeiraLetraUsuarioAutenticado()), 1)
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(),
                                _createElementVNode("span", _hoisted_17, [
                                  _createTextVNode(_toDisplayString(_ctx.storeApp.getters.nomeUsuarioAutenticado()) + " ", 1),
                                  _createVNode(_component_icone, { nome: "seta-baixo" })
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_layout_content, { class: "ui-layout-content" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_router_view, null, {
                      default: _withCtx(({ Component }) => [
                        _createVNode(_Transition, {
                          name: "fade",
                          mode: "out-in"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["class"])
          ]),
          _: 1
        })
      ]))
    : _createCommentVNode("", true)
}